import { schema } from 'normalizr';
import { SCHEMA_TYPE_VENDORS } from '../constants/schemaTypes';
import vendorAuthTemplateSchema from './vendorAuthTemplate';
import vendorEndpointSchema from './vendorEndpoint';

const vendorSchema = new schema.Entity(SCHEMA_TYPE_VENDORS, {
  auth_templates: [vendorAuthTemplateSchema],
  vendor_endpoints: [vendorEndpointSchema],
});

export default vendorSchema;
